// Kill-switch de EMERGÊNCIA do painel de artefato — não é a decisão por
// cartão. `false` força CADA cartão de dados inline (o modo legado, como
// sempre foi), sem deploy de backend; `true` delega a decisão ao backend, que
// manda `ui.apresentacao: 'inline' | 'painel'` por cartão (ausente = painel;
// ver `ui-registry/apresentacao.js`). Entra no getter `modoArtefatoAtivo`
// (`store/artefato.js`) junto do `modoAtivo` da imersiva.
export const ARTEFATO_MODO_ATIVO = true

// Kill-switch do botão "Personalizar meu painel" (painel de insights da
// /home-ia). Controla SÓ a visibilidade do botão — o editor, a leitura da
// preferência e a aplicação dela no painel ficam prontos e inertes. Soma-se
// ao GUARD do backend (`view-chat-imersivo.vue::personalizacaoBackendDisponivel`):
// mesmo com `true` aqui, sem o endpoint `GET /painel/preferencia` responder
// 200 a tela fica no padrão e o botão some. Persistência REAL é no backend
// (`api/apiPainelPreferencia.js`); o `localStorage` é só cache da primeira
// pintura (`utils/preferencia-de-insights.js`).
export const PERSONALIZACAO_PAINEL_ATIVA = true

// Kill-switch do PAINEL DA CONVERSA na /home-ia (§5.1 do CLAUDE.md do
// módulo): cartão flutuante no canto do trilho (Progresso / Entregas /
// Contexto), com as entregas abrindo no aside. Ligado na release chat-ia-v4
// (sobe com o backend do `plano`); `false` volta ao índice "Entregas" + régua.
// Lido num `data` do `messages.vue` (trocável em teste).
export const PAINEL_PROGRESSO_CONTEXTO_ATIVO = true

/**
 * Kill-switch das CONVERSAS EM ABAS na `/home-ia` (§5.1 do CLAUDE.md do
 * módulo). `false` volta a UMA conversa por vez, como era antes do modo
 * paralelo.
 *
 * ★ Pedido do owner (20/09/2026): *"tem como fazer um kill switch para o
 * usuário não usar abas? tá bem confuso e tenho medo"*. Com a barra na tela,
 * quem nunca precisou de paralelismo ganha um segundo eixo de navegação ao
 * lado de "Recentes" sem pedir — e a dúvida *"recentes e as abas são a mesma
 * coisa então?"* nasce daí. Desligar devolve o produto ao formato conhecido
 * sem tirar uma linha de código do lugar.
 *
 * O que `false` DESLIGA:
 * - a barra de abas não renderiza;
 * - a tela nasce (e fica) com UMA conversa viva — as excedentes que estiverem
 *   no registro são FECHADAS na montagem, para não sobrar stream sem dono;
 * - as abas não são guardadas nem retomadas entre cargas
 *   (`views/chat-imersivo/abas-persistidas.js`).
 *
 * O que `false` NÃO desliga, e é de propósito: a conversa continua tendo
 * namespace Vuex e motor próprios (`iaConversa:<uuid>`). É essa arquitetura
 * que sustenta a encenação do plano, o painel de artefato e o histórico
 * compartilhado — todos já caem no `STORE` fixo sozinhos quando não há
 * conversa viva, então nada aqui depende do número de abas.
 *
 * Voltar a `true` é seguro a qualquer momento: sem abas guardadas, a próxima
 * carga simplesmente nasce com uma aba e o "+" volta a existir.
 */
export const CONVERSAS_EM_ABAS_ATIVO = true
